module.exports = __webpack_public_path__ + "img/title2.ba7c7571.png";